/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
import { axiosProtectedApi, axiosWebservice } from './setup';
import qs from 'qs';

export async function resetPassword (email) {
  const api = axiosWebservice();
  const response = await api.post(
    'password/resettoken',
    qs.stringify({
      ismobile: true,
      email: email
    })
  );
  return response && response.data && response.data.status;
}

export async function getProfile () {
  const api = axiosProtectedApi();
  const response = await api.post('user/presence/init');
  return response && response.data && response.data.status
    ? response.data
    : null;
}

export async function getUsersByHash (hashs) {
  const api = axiosWebservice();
  const response = await api.post(
    'profile/usersinfo',
    qs.stringify({ userhashs: hashs })
  );
  return response && response.data && response.data.status && response.data.users
    ? response.data.users
    : null;
}

export async function uploadProfileImage (selectedFile, progressCallBack) {
  const api = axiosProtectedApi();

  const formData = new FormData();
  formData.append('profpic', selectedFile, selectedFile.name);
  const response = await api.post('user/profile/uploadpic', formData, {
    onUploadProgress: progressEvent => {
      if (typeof progressCallBack === 'function') {
        progressCallBack(progressEvent.loaded / progressEvent.total);
      }
    }
  });

  return response && response.data && response.data.status
    ? response.data
    : null;
}

export async function updateProfile (data) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/profile/update',
    qs.stringify({ data })
  );

  return response && response.data && response.data.status
    ? response.data
    : null;
}

export async function linkEndpoint ({ endpoint, defaultdevice }) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/endpoint/link',
    qs.stringify({
      endpoint,
      defaultdevice
    })
  );

  return response && response.data && response.data.status
    ? response.data
    : null;
}

export async function unlinkEndpoint () {
  const api = axiosProtectedApi();

  const response = await api.post('user/endpoint/unlink', qs.stringify({}));

  return response && response.data && response.data.status
    ? response.data
    : null;
}

export async function lockProfile (pin) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/profile/lockprofile',
    qs.stringify({
      profilepin: pin
    })
  );

  return response && response.data && response.data.status
    ? response.data
    : null;
}

export async function unlockProfile (pin) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/profile/unlockprofile',
    qs.stringify({
      profilepin: pin
    })
  );

  return response && response.data && response.data.status
    ? response.data
    : null;
}

/*
 * Depricated: updateAutoAnswerFav is not needed as per new implementation.
 * Auto answer is now device specific
 */

export async function updateAutoAnswerFav (enabled) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/profile/autoanswerfav',
    qs.stringify({
      status: !!enabled
    })
  );

  return response && response.data && response.data.status;
}

export async function updateStatus (status) {
  const api = axiosProtectedApi();

  const response = await api.post(
    `user/status/${status ? 'online' : 'offline'}`
  );

  return response && response.data && response.data.status;
}

export async function updateVMR ({ enabled, pin }) {
  const api = axiosProtectedApi();
  const data = {
    vmrenabled: enabled ? 1 : 0
  };
  if (pin) {
    data.vmr_pin = pin;
  }
  const response = await api.post(
    'user/profile/updatevmr',
    qs.stringify({ data })
  );

  return response && response.data && response.data.status;
}
export async function updateSuperEasy (enabled) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/profile/updatesupereasymode',
    qs.stringify({
      status: !!enabled
    })
  );

  return response && response.data && response.data.status;
}
export async function updateDirSettings ({
  showindir,
  showindomaindir,
  showaddressindir,
  showdialindir,
  showstatusindir
}) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/profile/updatedirsettings',
    qs.stringify({
      data: {
        permissions: {
          showindir,
          showindomaindir,
          showaddressindir,
          showdialindir,
          showstatusindir
        }
      }
    })
  );

  return response && response.data ? response.data : null;
}
export async function updatePassword ({ currpass, newpass }) {
  const api = axiosProtectedApi();

  const response = await api.post(
    'user/profile/updatepass',
    qs.stringify({
      data: { currpass, newpass }
    })
  );

  return response && response.data ? response.data : null;
}
